import { z } from "zod";

export const lineItemReasonSchema = z.object({
  reasonId: z.string().min(1, "Veuillez sélectionner une raison"),
  comment: z.string().nullable().default(null),
  images: z.array(z.instanceof(File)).default([]),
});

export type LineItemReasonFormValues = z.infer<typeof lineItemReasonSchema>;

export interface LineItemReasonSchemaOpts {
  requiresComment: boolean;
  requiresPhoto: boolean;
}

export function createLineItemReasonSchema(opts: LineItemReasonSchemaOpts) {
  return z.object({
    reasonId: z.string().min(1, "Veuillez sélectionner une raison"),
    comment: opts.requiresComment
      ? z
          .string()
          .nullable()
          .refine((v) => v !== null && v.trim().length > 0, {
            message: "Un commentaire est requis pour cette raison",
          })
          .default(null)
      : z.string().nullable().default(null),
    images: opts.requiresPhoto
      ? z
          .array(z.instanceof(File))
          .min(1, "Au moins une photo est requise pour cette raison")
          .default([])
      : z.array(z.instanceof(File)).default([]),
  });
}
